import * as Yup from 'yup';

export const IndicateIssuesSchema = Yup.object().shape({
    issue: Yup.string().min(1, 'Issue is required').required('Issue is required'),
});

export type IndicateIssuesDataType = Yup.InferType<typeof IndicateIssuesSchema>;

type InitialValues = {
    issue: string;
};

export const IndicateIssuesInitialValues: InitialValues = {
    issue: '',
};

export interface IndicateIssuesInterface {
    issue: string;
}
